<div class="form-overview" data-uiid="form-overview">
    <div class="detail-page-action-bar">
        @if (permissions.IsCreator) {
            <button
                class="btn btn-cerrix me-2"
                (click)="addNewForm()"
            >
                <i class="fas fa-plus-circle"></i>
                <span class="d-none d-lg-inline">{{ 'formOverview.addNewFormBtn' | t }}</span>
            </button>
        }

        <input
            data-uiid="input-formfilter"
            type="text"
            class="form-control quick-search ms-2"
            placeholder="{{ 'formOverview.filterPlaceholder' | t }}"
            (debounce-input-event)="filterForms()"
            [(ngModel)]="filter"
            inputTooltip
        />

        @if (permissions.IsCategoryAdministrator || permissions.IsGroupAdministrator) {
            <div class="workflow-area">
                <div class="btn-group extra-actions">
                    @if (permissions.IsCategoryAdministrator) {
                        <button
                            class="btn btn-outline-secondary"
                            (click)="openCategoriesSD()"
                            title="{{ 'formOverview.categoriesBtn' | t }}"
                        >
                            <i class="fas fa-th-large" aria-hidden="true"></i>
                            <span class="d-none d-xl-inline ms-2">{{ 'formOverview.categoriesBtn' | t }}</span>
                        </button>
                    }
                    @if (permissions.IsGroupAdministrator) {
                        <button
                            class="btn btn-outline-secondary"
                            (click)="openGroupSD()"
                            title="{{ 'formOverview.groupsBtn' | t }}"
                        >
                            <i class="fas fa-users" aria-hidden="true"></i>
                            <span class="d-none d-xl-inline ms-2">{{ 'formOverview.groupsBtn' | t }}</span>
                        </button>
                    }
                </div>
            </div>
        }
    </div>

    @if (scopedCategories) {
        @if (scopedCategories.length > 0) {
            <div class="all-forms overview-content">
                @for (group of scopedCategories; track group) {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">
                            {{ group.Category }}
                        </div>
                        <div class="detail-page-card-body padded">
                            <ul class="form-cards">
                                @for (form of group.Forms; track form) {
                                    <li class="card clickable" data-uiid="form-preview">
                                        <div
                                            class="card-img-top main"
                                            (click)="openForm(form)"
                                            [style.backgroundImage]="
                                                'url(' +
                                                (form.ImageGuid
                                                    ? 'api/forms/thumbnail/' + form.ImageGuid
                                                    : '/static/images/form_logo_fallback.jpg') +
                                                ')'
                                            "
                                            data-uiid="btn-open-form"
                                        ></div>
                                        <div class="card-body" (click)="openForm(form)">
                                            <h5 class="card-title" data-uiid="label-form-title">
                                                {{ form.Title }}
                                                @if (form.CanEdit && form.HasDraft) {
                                                    <i
                                                        class="fas fa-file-signature ms-2"
                                                        [matTooltip]="'formOverview.hasDraftsTooltip' | t"
                                                    ></i>
                                                }
                                            </h5>
                                            <p class="card-text" title="{{ form.Description }}">
                                                {{ form.Description }}
                                            </p>
                                        </div>
                                        @if (
                                            form.CanEdit ||
                                            form.CanToggleStatus ||
                                            form.CanDelete ||
                                            form.CanInvite
                                        ) {
                                            <div class="card-footer text-muted text-start">
                                                @if (form.CanEdit) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-cerrix"
                                                        data-uiid="button-edit-form"
                                                        (click)="editForm(form)"
                                                    >
                                                        <i
                                                            class="far fa-edit"
                                                            aria-hidden="true"
                                                        ></i>
                                                        <span class="d-none d-xl-inline">{{ 'formOverview.editBtn' | t }}</span>
                                                    </button>
                                                }
                                                @if (form.CanToggleStatus) {
                                                    <button
                                                        type="button"
                                                        data-uiid="button-togglestatus"
                                                        (click)="toggleIsOpenForEntries(form)"
                                                        [matTooltip]="
                                                            'formOverview.openStateTooltip'
                                                                | t
                                                                    : {
                                                                          state: form.IsOpenForEntries
                                                                              ? form.FormOutOfDateRange
                                                                                  ? 'halted'
                                                                                  : 'open'
                                                                              : 'closed',
                                                                      }
                                                        "
                                                        class="btn btn-{{
                                                            form.IsOpenForEntries
                                                                ? form.FormOutOfDateRange
                                                                    ? 'warning'
                                                                    : 'success'
                                                                : 'danger'
                                                        }} ms-1"
                                                    >
                                                        @if (
                                                            form.IsOpenForEntries &&
                                                            form.FormOutOfDateRange
                                                        ) {
                                                            <i
                                                                class="fas fa-calendar-times"
                                                                aria-hidden="true"
                                                            ></i>
                                                        } @else {
                                                            <i
                                                                class="fas fa-toggle-{{
                                                                    form.IsOpenForEntries
                                                                        ? 'on'
                                                                        : 'off'
                                                                }}"
                                                                aria-hidden="true"
                                                            ></i>
                                                        }
                                                        <span class="d-none d-xl-inline ms-2">
                                                            {{
                                                                'formOverview.toggleOpenBtn'
                                                                    | t
                                                                        : {
                                                                              state: form.IsOpenForEntries
                                                                                  ? "open"
                                                                                  : "closed",
                                                                          }
                                                            }}
                                                        </span>
                                                    </button>
                                                }
                                                @if (form.CanDelete || form.CanInvite) {
                                                    <div class="btn-group dropup float-end">
                                                        <button
                                                            type="button"
                                                            class="btn btn-outline-secondary dropdown-toggle"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                            data-uiid="button-form-options"
                                                        >
                                                            <i
                                                                class="fas fa-ellipsis-v fa-lg"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button>
                                                        <div
                                                            class="dropdown-menu dropdown-menu-right"
                                                        >
                                                            <!-- Dropdown menu links -->
                                                            @if (form.CanDelete) {
                                                                <a
                                                                    class="dropdown-item"
                                                                    data-uiid="button-delete-form"
                                                                    (click)="deleteForm(form)"
                                                                    >{{ 'formOverview.deleteBtn' | t }}</a
                                                                >
                                                            }
                                                            @if (form.CanInvite) {
                                                                <a
                                                                    class="dropdown-item"
                                                                    data-uiid="button-invite-form"
                                                                    (click)="inviteForm(form)"
                                                                    >{{ 'formOverview.inviteBtn' | t }}</a
                                                                >
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>
        } @else {
            <div class="no-forms-info">
                @if (filter) {
                    {{ 'formOverview.noFormsMatching' | t }}
                } @else {
                    {{ 'formOverview.noFormsAvailable' | t }}
                }
            </div>
        }
    } @else {
        <div class="fancy-loader"></div>
    }
</div>
